import { fetchWithAuth } from "@/providers/auth-provider";
import type { ServiceResponse } from "@/types/services";

import { WebAppRoutes } from "types/web-app";
import type { CompleteBattleLog } from "types/battle-engine";
import type { PokeType } from "types/pokemon/poke-type";

export interface StartSandboxBattleInput {
  pokemon_id: number;
  active_skills: string[];
  dummy_types: PokeType[];
}

export interface StartSandboxBattleOutput {
  battle_log: CompleteBattleLog | null;
  bot_name: string;
  bot_country: string | null;
}

export const startSandboxBattle = async (
  accessToken: string,
  input: StartSandboxBattleInput,
): Promise<ServiceResponse<StartSandboxBattleOutput>> => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.START_SANDBOX_BATTLE,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<StartSandboxBattleOutput>;
  } catch (error) {
    console.error("Error starting sandbox battle:", error);
    return {
      statusCode: 500,
      ok: false,
      message:
        error instanceof Error ? error.message : "Failed to start sandbox battle",
      data: {
        battle_log: null,
        bot_name: "",
        bot_country: null,
      },
    };
  }
};

